const website = {
  link: "https://eztop.in",
  name: "Eztop",
  instagram: "",
  facebook: "",
  whatsapp: "",
};

export default website;
